import React from 'react'

export const Spacer = props => {
    const { element } = props;
    
    return (
        <div className={"spacer" + (element.className ? " " + element.className : "")}>
            &nbsp;
        </div>
    )
}